import canvasConfetti from 'canvas-confetti';
/**
 * 
 * @param {string} pattern
 */
export default function confetti(pattern) {
  const colors = ['#A4CE3A', '#2B9EC6', '#F04880', '#EF6C00', '#9C27B0'],
    zIndex = 2000;

  if (pattern === 'fireworks') {
    const duration = 3 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: zIndex, colors: colors };
    const randomInRange = (min, max) => Math.random() * (max - min) + min;
    let interval = setInterval(() => {
      let timeLeft = animationEnd - Date.now();
      if (timeLeft <= 0) {
        return clearInterval(interval);
      }
      const particleCount = 50 * (timeLeft / duration);
      canvasConfetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
      canvasConfetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
    }, 250);
  } else {
    const particleCount = 50,
      spread = 80,
      originY = -0.15;

    canvasConfetti({
      particleCount: particleCount,
      angle: 315,
      spread: spread,
      origin: { x: 0, y: originY },
      colors: colors,
      zIndex: zIndex
    });
    canvasConfetti({
      particleCount: particleCount,
      angle: 225,
      spread: spread,
      origin: { x: 1, y: originY },
      colors: colors,
      zIndex: zIndex
    });
  }
}